
import { User_Guide_Api } from "../config/api/UserGuide";
import { callApi } from "../utils/apiClient";

export const loadUserGuideList = async (payload) => {
    try {      
        return await callApi(User_Guide_Api.user_guide_crud.list, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading bin type list:", error);
        throw error;
    }
};

export const loadUserGuideListByID = async (payload) => {
    try {      
        return await callApi(User_Guide_Api.user_guide_crud.list_by_id, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading bin type list:", error);
        throw error;
    }
};